import React, { createContext, useState, useContext, ReactNode } from 'react';
import PaywallDialog from '../components/PaywallDialog';

// Contextの型定義
interface PaywallContextType {
  openPaywall: () => void;
  closePaywall: () => void;
}

// Contextの作成
const PaywallContext = createContext<PaywallContextType | undefined>(undefined);

export const usePaywall = () => {
  const context = useContext(PaywallContext);
  if (!context) {
    throw new Error('usePaywall must be used within a PaywallProvider');
  }
  return context;
};

export const PaywallProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const openPaywall = () => setIsVisible(true);
  const closePaywall = () => setIsVisible(false);

  return (
    <PaywallContext.Provider value={{ openPaywall, closePaywall }}>
      {children}
      <PaywallDialog isVisible={isVisible} onClose={closePaywall} />
    </PaywallContext.Provider>
  );
};
